<img [src]="imgURL" *ngIf="type === TYPE_IMAGE" (error)="onLoadError()" (load)="onImageLoad($event)" />
